import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ChipProps {
    children: ReactNode
    tone?: 'cream' | 'outline' | 'soft'
    icon?: ReactNode
    className?: string
}

/** Rounded label pill used for room specs, service tags and hero badges. */
export const Chip: FC<ChipProps> = ({
    children,
    tone = 'cream',
    icon,
    className
}): ReactNode => {
    const tones = {
        cream: 'bg-cream text-ink',
        soft: 'bg-cream-deep text-brand',
        outline: 'border border-hairline-strong text-ink'
    }

    return (
        <span
            className={cn(
                'inline-flex items-center gap-2 rounded-full px-4 py-2 text-[14px] font-medium leading-none',
                tones[tone],
                className
            )}
        >
            {icon}
            {children}
        </span>
    )
}
